import { BUTTON, LAYOUT_COLUMNS, LAYOUT_LIST, TEXT } from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import {
  EditableLinkButtonHelper,
  getButtonId,
  getButtonTitle,
  getButtonUrl,
  hasButton
} from './itemHelpers/LinkButtonHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';
import {
  OPTIONAL_TEXT_FIELDS,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

export const Interactive8: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  const { contentEditable } = useEditorStore.getState();

  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card': {
        const cardItem = item as ItemOfType<'Card'>;
        const buttonId = getButtonId(cardItem);
        const buttonTitle = getButtonTitle(cardItem);
        const buttonUrl = getButtonUrl(cardItem);

        // A card without a button of its own has nothing to save edits to,
        // so the editor shows the default button learners get.
        const buttonDefinition =
          contentEditable && hasButton(cardItem)
            ? EditableLinkButtonHelper(cardItem, { learnerDefaults: true })
            : {
                type: BUTTON as typeof BUTTON,
                id: buttonId,
                values: {
                  type: 'link',
                  title: buttonTitle,
                  url: buttonUrl,
                  showShadow: true
                },
                items: [] as never[]
              };

        return {
          id: cardItem.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(
              {
                ...cardItem,
                title: '',
                body: ''
              },
              {
                width: '80vw',
                height: 'auto',
                padding: { _: '0px', md: '60px' },
                optional: ['subtitle'],
                extraItems: [
                  {
                    id: `${cardItem.id}_title`,
                    type: TEXT,
                    values: {
                      ...optionalFieldValues(optional, 'title'),
                      value: cardItem.title,
                      variant: 'heading1'
                    },
                    items: []
                  },
                  {
                    type: LAYOUT_COLUMNS,
                    id: '1',
                    values: {
                      gridTemplateColumns: '1fr'
                    },
                    items: [
                      {
                        id: `${cardItem.id}_body`,
                        type: TEXT,
                        values: {
                          ...optionalFieldValues(optional, 'body'),
                          value: cardItem.body
                        },
                        items: []
                      },
                      buttonDefinition
                    ]
                  }
                ]
              }
            )
          ]
        };
      }
      default:
        return null;
    }
  });
};
